module.exports = __webpack_public_path__ + "img/MFT白皮书_55.3ae79409.jpg";